import { Component } from '@angular/core';
import {MatButton} from "@angular/material/button";
import {scrollToContactSection} from '../../../../utils/helper';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-imrpove',
  imports: [
    MatButton,
    TranslatePipe
  ],
  templateUrl: './imrpove.component.html',
  styleUrl: './imrpove.component.scss'
})
export class ImrpoveComponent {
  public onContactClicked() {
    scrollToContactSection();
  }
}
